import React, { useEffect } from 'react';
import styles from '../styles.module.scss';
import { createSearchPanel } from '../utils';

interface ISearchPanel {
    device: 'PC' | 'M';
}

const SearchPanelContent = ({ device }: ISearchPanel) => {
    useEffect(() => {
        createSearchPanel({ device: device });
    }, [device]);

    const deviceName = `searchpanel${device}`;
    return (
        <div className={styles[deviceName]} id={deviceName}>
            searchpanel
        </div>
    );
};

export default SearchPanelContent;
